<template>
  <div 
    :class="'message_item' + (useAuth().getId() == message.user_id || message.guest_id ? ' is_my ' : '')"
    :data-message-id="message.id"
    >
    <div class="text">
      <NuxtLink 
        v-if="room?.is_group && !message.is_my"
        :to="'/grower/' + message.user_name" 
        class="user-name">
        {{ message.user_name }}
      </NuxtLink>
      <div>
        <span v-html="formatChatMessageText(message.text)"></span>
        <span :class="message.text.includes('\n') ? 'dt is-nl' : 'dt'">
          {{ ($dayjs as any).utc(($dayjs as any).unix(message.add_date)).fromNow() }}
        </span>
      </div>
    </div>      
  </div>
</template>

<script setup lang="ts">
import { formatChatMessageText } from '@/types/other'

interface Message {
  user_id: string | number
  guest_id?: string | number  
  user_name: string
  text: string
  add_date: number
  is_my?: boolean
}

interface Room {
  is_group?: boolean
}

interface Props {
  message: Message
  room?: Room
  addDate: string // Для TimeGroupedList (ISO строка)
}

const props = defineProps<Props>()
</script>

<style scoped>
.message_item {
  margin-bottom: 3px;
  display: flex;
  align-items: flex-start;
  justify-content: flex-start;
  flex-wrap: wrap;
  width: 100%;
}

.message_item.is_my {
  text-align: right;
  justify-content: flex-end;
  flex-direction: row-reverse;
}

.message_item.is_my .text {
  margin-right: 0px;
  word-wrap: break-word;
  margin-left: auto;
  white-space: pre-wrap;
  background-color: var(--gd-chat-message-background-color);
  border-radius: 15px 15px 5px 15px;
}

.text {
  display: inline-block;
  background-color: var(--un-background-color-gray);
  padding: 6px 15px;
  position: relative;
  max-width: calc(100% - 90px);
  word-wrap: break-word;
  white-space: pre-wrap;
  border-radius: 15px 15px 15px 5px;
}

.text:before {
  content: "\A";
  border-style: solid;
  border-width: 10px 10px 0px 0;
  border-radius: 4px;
  border-color: transparent var(--un-background-color-gray) transparent transparent;
  position: absolute;
  right: calc(100% - 3px);
  bottom: 0px;
}

.message_item.is_my .text:before {
  width: 0;
  height: 0;
  border-style: solid;
  border-width: 10px 0 0px 10px;
  border-radius: 4px;
  border-color: transparent transparent transparent var(--gd-chat-message-background-color);
  left: calc(100% - 3px);
}

.text .user-name {
  font-weight: bold;
  font-size: 0.75rem;
  color: var(--un-text-color);
  text-decoration: none;
}

.text .user-name:hover {
  color: black;
}

.text .dt {
  font-size: 0.65rem;
  color: gray;
  opacity: 0.7;
  margin-left: 0.5rem;
}

.text .dt.is-nl {
  display: block;
  width: 100%;
  text-align: right;
  margin-left: 0;
}

.message_item .text.is_new {
  background-color: #edf9e6;
  color: #494949;
}
</style>
